import { StaticMesh } from "./StaticMesh";
import { Robot } from "./Robot";
import { CubeTexture, Matrix4, MeshStandardMaterial, Texture, Vector3 } from "three";

export class Inventory {
    static SM_PatientBed: { [id: string]: { SM_Patient: StaticMesh; SM_Bed: StaticMesh } } = {};
    static SM_console: StaticMesh;
    static SM_stack: StaticMesh;
    static SM_trolley: StaticMesh;
    static SM_anesthesia: StaticMesh;
    static SM_surgeon: StaticMesh;
    static SM_slave: StaticMesh;
    static SM_trocar: StaticMesh;
    static T_envMap: CubeTexture;
    static Ports: {
        [procedure: string]: { [id: string]: { position: Vector3; matrix: Matrix4 } };
    } = {};
    static M_trocar2: MeshStandardMaterial;
    static M_trocar: MeshStandardMaterial;
    static textures: { [id: string]: Texture } = {};
    static iBsu: Robot;
    static vBsu: Robot;
    static MaxConsole = 1;
    static MaxStack = 1;
    static MaxTrolley = 1;
    static MaxAnesthesia = 1;
    static MaxSurgeon = 1;
    static MaxSlave = 1;
    static MaxTrocar = 6;
    static MaxBSU = 5;
    static colors: { [id: string]: { name: string; hexColor: string; isUsed: boolean } } = {};
    static usedColor: string[] = [];

    setConsole(sm: StaticMesh): void {
        Inventory.SM_console = sm;
    }
    setTrocar(sm: StaticMesh): void {
        Inventory.SM_trocar = sm;
    }
    setSurgeon(sm: StaticMesh): void {
        Inventory.SM_surgeon = sm;
    }
    setSlave(sm: StaticMesh): void {
        Inventory.SM_slave = sm;
    }
    addPatientBed(name: string, patient: StaticMesh, bed: StaticMesh): void {
        Inventory.SM_PatientBed[name] = { SM_Patient: patient, SM_Bed: bed };
    }

    addIBSU(r: Robot): void {
        Inventory.iBsu = r;
    }

    addVBSU(r: Robot): void {
        Inventory.vBsu = r;
    }
    static getAvailableColor():
        | undefined
        | {
              name: string;
              hexColor: string;
              isUsed: boolean;
          } {
        for (const key in Inventory.colors) {
            if (!Inventory.colors[key].isUsed) {
                return Inventory.colors[key];
            }
        }
    }
    static getBSUColor(id: string):
        | undefined
        | {
              name: string;
              hexColor: string;
              isUsed: boolean;
          } {
        const color = Inventory.colors[id];
        if (!color) return;
        color.isUsed = true;
        return color;
    }
}
